import { render, staticRenderFns } from "./AudioPlayerModal.vue?vue&type=template&id=1996aa79"
import script from "./AudioPlayerModal.vue?vue&type=script&lang=js"
export * from "./AudioPlayerModal.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayerModal.vue?vue&type=style&index=0&id=1996aa79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports